import React from "react";

export default function Slide({ nbSlide, image, title, description }) {
  return (
    <div className="flex lg:flex-row flex-col-reverse justify-center lg:items-end items-center w-screen">
      <div className="lg:w-2/5 w-2/5 flex lg:justify-end justify-center">
        <img src={image} alt="mockup" className="md:w-[300px]" />
      </div>
      <div className="flex flex-col lg:gap-y-20 gap-y-10 items-start lg:pb-32 lg:w-3/5 lg:ml-40 lg:px-0 px-4">
        {nbSlide === 1 ? (
          <div className="font-bold lg:text-4xl text-3xl h-20 mb-8 lg:mb-0">
            Comment ça marche ? <br></br>
            <span className="font-normal text-2xl">
              Comme une application de rencontre
            </span>
          </div>
        ) : (
          <div className="h-20"></div>
        )}
        <div className="flex justify-between gap-x-6">
          <div className="lg:min-h-[80px] lg:min-w-[80px] lg:max-h-[80px] lg:max-w-[80px] min-h-[60px] min-w-[60px] max-h-[60px] max-w-[60px] bg-primary text-white rounded-full flex items-center justify-center">
            <span className="lg:text-3xl text-2xl">{nbSlide}</span>
          </div>
          <div className="text-gray-800 flex flex-col gap-y-4 lg:py-5">
            <span className="lg:text-4xl text-2xl font-semibold text-gray-700">
              {title}
            </span>
            <span className="lg:text-xl text-lg text-gray-400 h-16 max-w-lg lg:mb-0 mb-14">
              {description}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
